import { SxProps, Theme } from '@mui/material';

export const styles: Record<string, SxProps<Theme>> = {
  root: {
    marginBottom: 2,
  },
  breadcrumbs: {
    fontSize: '0.875rem',
    paddingBottom: '15px',
  },
  link: {
    color: '#1976d2', // azul para link clicável
    cursor: 'pointer',
    '&:hover': {
      textDecoration: 'underline',
    },
  },
  current: {
    color: '#D2691E', // laranja para etapa atual
    fontSize: '0.875rem',
  },
};
